import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [],
  count: {
    total: 0,
    unread: 0,
    by_source: {
      event: 0,
      report: 0,
        automatic_report: 0,
      communication: 0,
      recommendation: 0,
    },
  },
  isFetching: false,
  hasLoaded: false,
  error: false,
};

const buildCountFromItems = (items = []) => {
  const unreadItems = items.filter((item) => !item?.is_read);
  const globalUnreadItems = unreadItems.filter((item) =>
    ["event", "report", "automatic_report"].includes(item?.source)
  );

  const eventUnread = globalUnreadItems.filter(
    (item) => item?.source === "event"
  ).length;

  const reportUnread = globalUnreadItems.filter(
    (item) => item?.source === "report"
  ).length;

  const automaticReportUnread = globalUnreadItems.filter(
    (item) => item?.source === "automatic_report"
  ).length;

  const communicationUnread = globalUnreadItems.filter(
    (item) => item?.source === "communication"
  ).length;

  return {
    total: globalUnreadItems.length,
    unread: globalUnreadItems.length,
    by_source: {
      event: eventUnread,
      report: reportUnread,
      automatic_report: automaticReportUnread,
      communication: communicationUnread,
      recommendation: 0,
    },
  };
};

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    getNotificationsStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },

    getNotificationsSuccess: (state, action) => {
      state.isFetching = false;
      state.error = false;
      state.hasLoaded = true;

      const incomingItems = Array.isArray(action.payload?.items)
        ? action.payload.items
        : [];

      state.items = incomingItems;
      state.count = buildCountFromItems(state.items);
    },

    getNotificationsFailure: (state) => {
      state.isFetching = false;
      state.error = true;
      state.hasLoaded = true;
    },

    updateNotificationReadStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },

    updateNotificationReadSuccess: (state, action) => {
      state.isFetching = false;
      state.error = false;

      const { source, id, is_read } = action.payload || {};
      const numericId = Number(id);

      state.items = state.items.map((item) => {
        const sameSource = item?.source === source;
        const sameId = Number(item?.source_id) === numericId;

        if (sameSource && sameId) {
          return {
            ...item,
            is_read: !!is_read,
          };
        }

        return item;
      });

      state.items = state.items.filter((item) => !item?.is_read);
      state.count = buildCountFromItems(state.items);
    },

    updateNotificationReadFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },

    resetNotificationsState: () => initialState,
  },
});

export const {
  getNotificationsStart,
  getNotificationsSuccess,
  getNotificationsFailure,
  updateNotificationReadStart,
  updateNotificationReadSuccess,
  updateNotificationReadFailure,
  resetNotificationsState,
} = notificationsSlice.actions;

export default notificationsSlice.reducer;
